import { SingleSpaAppStatus, SingleSpaEvent } from "../types/singleSpa.types";
import {
	triggerRouteChangeSpaEvent,
	triggerRouteChangeSpaMountEvent,
	triggerSaveProductListState,
	triggerWishlistUnmountedEvent,
	triggerCartUnmountedEvent,
} from "./routerActions";
import { isScrollTop, isValidRouterNavigation } from "./utils";
import { resetLastOrchestratorNavigatedUrl } from "./routerLinks";

const spaLoadingElement = document.getElementById("js-spa-loading");
const hideLoading = (): void => {
	if (spaLoadingElement) {
		spaLoadingElement.style.display = "none";
	}
};
const showLoading = (): void => {
	if (spaLoadingElement) {
		spaLoadingElement.style.display = null;
	}
};

const firstElement: HTMLElement | null = document.querySelector("#first-element");
window.addEventListener("single-spa:routing-event", ({ detail }: SingleSpaEvent) => {
	if (isValidRouterNavigation(detail)) {
		triggerRouteChangeSpaEvent(detail.newUrl);
		firstElement?.focus();
	}

	if (isScrollTop(detail)) {
		scrollTo(0, 0);
	}
	resetLastOrchestratorNavigatedUrl();
});

window.addEventListener("single-spa:before-routing-event", ({ detail }: SingleSpaEvent) => {
	if (isValidRouterNavigation(detail)) {
		if (detail.newAppStatuses["mf-productlist"] === SingleSpaAppStatus.NOT_MOUNTED) {
			triggerSaveProductListState(detail.oldUrl);
		}
		if (detail.newAppStatuses["mf-wishlist"] === SingleSpaAppStatus.NOT_MOUNTED) {
			triggerWishlistUnmountedEvent();
		}
		if (detail.newAppStatuses["mf-cart"] === SingleSpaAppStatus.NOT_MOUNTED) {
			triggerCartUnmountedEvent();
		}
	}
});

window.addEventListener("single-spa:before-app-change", ({ detail }: SingleSpaEvent) => {
	showLoading();
});

window.addEventListener("single-spa:app-change", ({ detail }: SingleSpaEvent) => {
	hideLoading();
	if (isValidRouterNavigation(detail)) {
		triggerRouteChangeSpaMountEvent(detail.appsByNewStatus[SingleSpaAppStatus.MOUNTED], detail.newUrl);
	}
});

window.addEventListener("single-spa:before-first-mount", () => {
	hideLoading();
});
